'use client'

/**
 * Recursively searches for the nearest ancestor element with the specified tag name.
 *
 * @param element - The starting HTMLElement from which to search up the DOM.
 * @param tagName - The tag name to find (case-insensitive, e.g., "button", "div").
 * @param depth - (Optional: should not be set manually!!!) The current depth of the traversal.
 * @returns An object with the found element and its depth from the original element, or null if not found.
 *
 * @example
 * const parent = findParentElement(clickedElement, 'button');
 * if (parent) {
 *   // parent.element is the found parent element
 *   // parent.depth is how far up the DOM it was found
 * }
 */
export const findParentElement = (
    element: HTMLElement | null,
    tagName: string,
    depth: number = 0,
): { element: HTMLElement; depth: number } | null => {
    if (!element) return null
    if (element.tagName && element.tagName.toLowerCase() === tagName) {
        return { element, depth }
    }
    return findParentElement(element.parentElement, tagName, depth + 1)
}
